<!-- 举手组件 -->
<template>
  <div id="menu-speak-apply"></div>
</template>

<script>

import language from '../../language/main'

const store = BJY.store
const eventEmitter = BJY.eventEmitter
const auth = BJY.auth
const userData = BJY.data.user
const config = BJY.config
auth.canOpenCameraWhenSpeaking = function (userType) {
  return true
}

export default {
  components: {},
  data() {
    return {
      player: null
    }
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {
  },
  mounted() {
    // 绑定一个结束发言事件
    const that = this
    eventEmitter.STOP_SPEAK_TRIGGER = 'stop_speak_trigger'
    eventEmitter
      .on(
        eventEmitter.SPEAK_APPLY_RESULT_TIMEOUT,
        (e, data) => {
          console.log('timeout')
          // this.$message.success(language.TIP_SPEAK_APPLY_TIMEOUT)
          // this.$message.success(language.TIP_SPEAK_APPLY_TIMEOUT)
        }
      )
      .on(
        eventEmitter.SPEAK_APPLY_RESULT_REJECT,
        (e, data) => {
          console.log('reject')
          this.$message.success(language.TIP_SPEAK_APPLY_REJECT)
          // this.$message.success(language.TIP_SPEAK_APPLY_REJECT)
        }
      )
      .on(
        eventEmitter.SPEAK_APPLY_RESULT_ACCEPT,
        (e, data) => {
          console.log('accept')
          this.$message.success(language.TIP_SPEAK_APPLY_ACCEPT)
          // this.$message.success(language.TIP_SPEAK_APPLY_ACCEPT)
          eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
            videoOn: true,
            audioOn: true
          })
        }
      )
      .on(eventEmitter.MEDIA_SWITCH_TRIGGER, function (e, data) {
        var videoOn = data.videoOn
        var audioOn = data.audioOn

        var operator = data.operator
        var prevAudioOn = store.get('user.audioOn')
        var prevVideoOn = store.get('user.videoOn')

        /**
         * 学生被远程开关设备
         */
        if (
          operator && auth.isStudent() && (operator.type === config.ROLE_TYPE_TEACHER || operator.type === config.ROLE_TYPE_ASSISTANT)
        ) {
          // 麦克风被远程打开或关闭
          if (prevAudioOn !== audioOn && prevVideoOn === videoOn) {
            if (audioOn) {
              // 麦克风被打开
              // this.$message.success('111111')
            } else {
              // 麦克风关闭
              //  this.$message.success('222222')
            }
          }

          // 摄像头被远程打开或关闭
          if (prevVideoOn !== videoOn && prevAudioOn === audioOn) {
            if (videoOn) {
              // 摄像头被打开
              //   this.$message.success('3333333')
            } else {
              // 摄像头被关闭
              //  that.$message.success('4444444')
            }
          }
        }

        if (!videoOn && !audioOn) {
          if (operator && operator.id === store.get('teacher.id')) {
            // 被老师终止发言
            that.$message.success('老师已为你下麦')
          }
        }
      })
      .on(
        eventEmitter.SPEAK_APPLY_FORBID_ALL_CHANGE,
        (e, data) => {
          console.log('data', data)
          if (data.cache) {
            this.$message.success(data.forbidAll ? language.INFO_FORBID_RAISE_HAND : language.INFO_UNFORBID_RAISE_HAND)
            // this.$message.success(data.forbidAll ? language.INFO_FORBID_RAISE_HAND : language.INFO_UNFORBID_RAISE_HAND)
          }
          if (data.forbidAll) {
            $('#menu-speak-apply').css({ 'display': 'none' })
          }
          if (!data.forbidAll) {
            $('#menu-speak-apply').css({ 'display': 'block' })
          }
        }
      )

    BJY.SpeakApplyMenu.create({
      element: $('#menu-speak-apply'),
      replace: false,
      // 举手按钮被点击
      onApplyClick: () => {
        if (store.get('class.started')) {
          if (BJY.data.class.getForbidSpeakApply()) {
            // this.$message.success(language.INFO_FORBID_RAISE_HAND)
            this.$message.success(language.INFO_FORBID_RAISE_HAND)
            return
          }
          if (userData.active().length >= store.get('partner.liveMaxSpeakers')) {
            // this.$message.success('当前上台人数已满')
            this.$message.success('当前上台人数已满')
            return
          }
          BJY.userSpeak.startApply(10 * 1000)
        } else {
          // this.$message.success(language.TIP_CLASS_NOT_START)
          this.$message.success(language.TIP_CLASS_NOT_START)
        }
        // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
        let mediaDevices = navigator.mediaDevices
        if (mediaDevices === undefined) {
          mediaDevices = {}
        }
        // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
        // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
        if (mediaDevices.getUserMedia === undefined) {
          mediaDevices.getUserMedia = function (constraints) {
            // 首先，如果有getUserMedia的话，就获得它
            var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia

            // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
            if (!getUserMedia) {
              return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
            }

            // 否则，为老的navigator.getUserMedia方法包裹一个Promise
            return new Promise(function (resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject)
            })
          }
        }
        mediaDevices.getUserMedia({ audio: true, video: true })
          .then(function (stream) {
            var video = document.querySelector('video')
            // 旧的浏览器可能没有srcObject
            if ('srcObject' in video) {
              video.srcObject = stream
            } else {
              // 防止在新的浏览器里使用它，应为它已经不再支持了
              video.src = window.URL.createObjectURL(stream)
            }
            video.onloadedmetadata = function (e) {
              video.play()
            }
          })
          .catch(function (err) {
            console.log(err)
            const error = err.toString()
            if (error.indexOf('Permission') !== -1) {
              that.$message.success('请前往浏览器设置，开启摄像头、麦克风权限')
            }
          })
      },
      // 取消举手被点击
      onCancelClick: () => {
        BJY.userSpeak.cancelApply()
      },
      // 结束发言被点击
      onStopClick: () => {
        this.$confirm({
          title: '确认挂断连麦吗?',
          content: '',
          okText: '确定',
          okType: 'primary',
          cancelText: '取消',
          onOk() {
            BJY.userSpeak.stopSpeak(BJY.store.get('user.id'))
            eventEmitter.trigger(eventEmitter.STOP_SPEAK_TRIGGER)
            eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
              videoOn: false,
              audioOn: false
            })
          },
          onCancel() {
            console.log('Cancel')
          },
        })
      }
    })
  },
  beforeDestroy() { }
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
